import Main from '@/views/administracion/configuracion/catalogos/contratosestatus/Main.vue';
import Default from '@/views/administracion/configuracion/catalogos/contratosestatus/Default.vue';

const auth = ['Catálogos:ver'];
const scopes = ['Catálogos:crear', 'Catálogos:editar', 'Catálogos:eliminar'];

const contratosestatus = [
  {
    path: 'contratosestatus',
    meta: {
      title: '',
      auth,
      scopes,
    },
    component: Main,
    children: [
      {
        name: 'catalogoContratosEstatus',
        path: '/',
        meta: {
          title: 'ContratosEstatus',
          auth,
          scopes,
        },
        component: Default,
      },
    ],
  },
];

export default contratosestatus;
